import _ from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

const Sdiv = styled.div`
  /* height: 100vh; */
  padding-bottom:101px;
  ${(props: any) => props.variantStyle}
`;

const useVariant = (stylePath) => {
  const pages: any = useSelector<any>((state) => state?.Cotizacion?.cotizacion?.styles?.pages);
  return _.get(pages, stylePath, '').replace(/\n/g, '').trim();
};

export const DIV = ({ children, stylePath, ...props }) => {
  const variant = useVariant(stylePath);

  return (
    <Sdiv
      //@ts-ignore
      variantStyle={variant}
      className={` animate__animated fadeIn ${props.className}`}
      {...props}
    >
      {children}
    </Sdiv>
  );
};
